import React, { useRef, useState } from 'react'
import { Dialog, DialogContent, TextField, Button, IconButton, CircularProgress } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { Toast } from 'components/shared/Toaster'
import strings from 'strings'
import { rejectTask } from 'actions/collaborativeTasks'

const RejectTaskModal = ({ open, onClose, task, onDone }) => {
    const t = strings.CT
    const [reason, setReason] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState(null)
    const inFlight = useRef(false)

    const handleClose = () => {
        setReason(''); setError(null); setSubmitting(false)
        inFlight.current = false
        onClose()
    }

    const handleSubmit = async () => {
        if (!reason.trim()) { setError(t.REQUIRED_REASON); return }
        if (inFlight.current) return
        inFlight.current = true
        setSubmitting(true)
        try {
            const res = await rejectTask(task.id, { reason: reason.trim() })()
            Toast({ type: 'success', message: t.REJECTED_OK })
            onDone && onDone(res?.response || res)
            handleClose()
        } catch (e) {
            Toast({ type: 'error', message: t.REJECTED_ERR })
        } finally {
            setSubmitting(false)
            inFlight.current = false
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth classes={{ paper: 'ct-modal-paper' }}>
            <DialogContent>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div className="ct-modal-title">{t.MODAL_REJECT_TITLE}</div>
                    <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
                </div>

                <label className="ct-field-label ct-field-label__required">{t.FIELD_REASON}</label>
                <TextField
                    variant="standard"
                    fullWidth
                    multiline
                    minRows={3}
                    placeholder={t.FIELD_REASON_PLACEHOLDER}
                    value={reason}
                    onChange={e => setReason(e.target.value)}
                    error={!!error}
                    helperText={error}
                    inputProps={{ maxLength: 1000 }}
                />

                <div className="ct-modal-footer">
                    <span />
                    <div style={{ display: 'flex', gap: 10 }}>
                        <Button onClick={handleClose} disabled={submitting}>{t.ACTION_CANCEL}</Button>
                        <Button
                            variant="contained"
                            style={{ background: 'var(--status-declined)', color: '#fff', textTransform: 'none', borderRadius: 10, fontWeight: 600 }}
                            onClick={handleSubmit}
                            disabled={submitting}
                            startIcon={submitting ? <CircularProgress size={14} style={{ color: '#fff' }} /> : null}
                        >
                            {t.ACTION_REJECT}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default RejectTaskModal
